<template>
    <transition :css="false" @enter="intro" @leave="outro">
        <div class="MainNavList-wrapper" v-show="mainNavVisible">
            <!--<hr class="main-divider">-->
            <div class="MainNavList-overlay" :style="style">
                <ul class="MainNavList" ref="MainNavListFill">
                    <li
                        ref="item"
                        :style="style"
                        :key="`MainNavListFill-${chapter.id}`"
                        class="MainNavList-item"
                        :class="itemModifiers(i)"
                        v-for="(chapter, i) in chapters">
                        <div>
                            <div class="MainNavList-title-container">
                                <!--<hr class="main-divider">-->
                                <h2 class="MainNavList-title">{{chapter.name }}</h2>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <ul class="MainNavList" ref="MainNavListOutlines">
                <li
                    ref="item"
                    :style="style"
                    :key="`MainNavListOutlines-${chapter.id}`"
                    :class="itemModifiers(i)"
                    class="MainNavList-item"
                    v-for="(chapter, i) in chapters"
                >
                    <div>
                        <div class="MainNavList-title-container">
                            <h2
                                @click="$emit('bttn-click', chapter.id)"
                                class="MainNavList-title">
                                {{chapter.name }}
                            </h2>
                        </div>
                        <transition name="fade">
                            <div
                                v-show="isActive(i) && !isDragging"
                                class="MainNavList-bttn"
                                @click="$emit('bttn-click', chapter.id)">
                                <small>Ver capítulo</small>
                                <div
                                    class="MainNavList-bttnIcon"
                                    :style="bttnIconStyle"
                                >
                                    <line-icon
                                        v-show="isActive(i) && !isDragging"
                                        :width="eyeIcon.width"
                                        :height="eyeIcon.height"
                                        :d="eyeIcon.d"
                                    ></line-icon>
                                </div>
                            </div>
                        </transition>
                    </div>
                </li>
            </ul>
        </div>
    </transition>
</template>

<script>
    import LineIcon from '@/app/components/LineIcon'
    import {mapGetters} from "vuex";

    export default {
        name: 'MainNavList',
        components: {
            LineIcon,
        },
        props: {
            itemHeight: {
                type: Number,
                required: true
            },
            chapters: {
                type: Array,
                required: true,
            },
            isDragging: {
                type: Boolean,
                required: true,
            },
        },
        data: () => ({
            active: 0,
            showButton: false,
            bttnIconVisible: false,
        }),
        methods: {
            toggle() {
                this.setMainNavVisible(!this.mainNavVisible);
            },
            intro(el, done) {
                TweenLite.fromTo(el, 0.3, {
                    alpha: 0,
                    scale: 1.2,
                }, {
                    alpha: 1,
                    scale: 1,
                    delay: 1,
                    overwrite: "all",
                    ease: Sine.easeOut,
                    onComplete: done,
                })
            },
            outro(el, done) {
                TweenLite.to(el, 0.3, {
                    alpha: 0,
                    overwrite: "all",
                    onComplete: done,
                    ease: Sine.easeOut,
                })
            },
            itemModifiers(index) {
                return {
                    'MainNavList-item--active': this.isActive(index),
                }
            },
            isActive(index) {
                return (this.activeIndex) === index;
            },
        },
        computed: {
            ...mapGetters(["mainNavVisible", "activeIndex"]),
            style() {
                return {
                    height: `${this.itemHeight}px`,
                }
            },
            eyeIcon() {
                const {$store} = this
                return $store.getters.data.lineIcons.eye
            },
            bttnIconStyle() {
                const {eyeIcon} = this
                return {
                    width: `${eyeIcon.width}px`,
                    height: `${eyeIcon.height}px`,
                }
            },
        },
    }
</script>

<style src="styles/components/MainNavList.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/MainNavList.vue